import React, { useState } from "react";
import { useHistory } from "react-router";
import { Button, Form, Input, Card} from "reactstrap";
import logoCiba from "../assets/images/logo.png";
import { useAuth } from "../context/authContext"

const initialState = { dni: "", password: "", msg: "" }

const LoginView = () => {
  const [state, setState] = useState(initialState)
  const { Login, } = useAuth();
  const history = useHistory()

  const handleInputChange = async (event) => {
    const target = event.nativeEvent.target;
    const name = target.name;
    const value = target.value;
    await setState({...state,
      [name]: value,
      msg:''
    });

  }

  const handleSearch = async (event) => {
    event.preventDefault();
    const res = await Login(state.dni, state.password)
    if(res.auth){
      history.push("/infosocio")
    }
    setState({...state, msg: res.msg})
  }

  const { msg } = state;

  return (
    <Form onSubmit={handleSearch}>
      <img src={logoCiba} className="logoCiba mt-4" alt=""  />
      <Card className="p-4 mt-3 text-center">
        <p className="text-left title">
          INGRESÁ Y DISFRUTA DE NUESTRA RED DE SERVICIOS 
        </p>
        <p>
          <Input
            name="dni"
            placeholder="DNI"
            type="text"
            className="inputDni"
            onChange={handleInputChange}
          />
        </p>
        <p>
          <Input
            name="password"
            placeholder="PASSWORD"
            type="password"
            className="inputDni"
            onChange={handleInputChange}
          />
        </p>
        <Button className="btn btn-continuar mb-3 mx-5" type="submit">
          Continuar
        </Button>
        <p className="text-danger">{msg}</p>
        <p><a href={`${process.env.PUBLIC_URL}/#/registro`} className="text-secondary">¿No estás registrado?</a></p>
        <p><a href={`${process.env.PUBLIC_URL}/#/recupero`} className="text-secondary">Olvidé mi contraseña</a></p>
      </Card>
    </Form>
  );
}

export default LoginView;
